module.exports = __webpack_public_path__ + "media/packs/images/markers/small-pod-2d3fc15c291ec95fa53adf3f9fd125f0.svg";